import { Building2 } from 'lucide-react'

export function LogoMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className="flex items-center gap-3">
      <span className="grid h-10 w-10 place-items-center rounded-xl bg-clay text-white shadow-sm">
        <Building2 aria-hidden="true" className="h-5 w-5" />
      </span>
      {!compact && (
        <span>
          <span className="block font-display text-xl font-bold leading-none tracking-tight">
            Directorio
          </span>
          <span className="mt-1 block text-[0.65rem] font-bold uppercase tracking-[0.22em] text-ink/50">
            Sistema de empresas
          </span>
        </span>
      )}
    </div>
  )
}
